import {forwardRef} from "react";
import {NodeViewWrapper, ReactNodeViewRenderer} from "@tiptap/react";
import {mergeAttributes, Node} from "@tiptap/core"
import DeeplinkView from "@/components/Deeplink/DeeplinkView";
import {generateUUID2} from "@/utils";

const DeeplinkNode = Node.create({
    name:'deeplink',
    inline: true,
    group: 'inline',
    attrs:{
        id:{
            default:null,
        },
    },

    addOptions:{
      fontSize:'17px'
    },

    parseHTML(){
        return[
            {
                tag:'deeplink',
                getAttrs: (dom) => ({
                    id: dom.getAttribute("data-id"),
                }),
            }
        ]
    },
    addAttributes(){
      return{
          id:{
              default:generateUUID2()
          },
          text:null,
          href:null,
          image:null,
          type:null,//类型，大图或链接
          isFirst:null,
          ifhidden: {
              default: false,
              renderHTML: attributes => {
                  if (attributes.ifhidden === undefined) {
                      return {};
                  }
                  return {
                      'ifhidden': attributes.ifhidden,
                  };
              },
          },
          isExclusiveDeeplink:null,
      }
    },
    onUpdate(){
    },
    renderHTML({HTMLAttributes}){
        return ["deeplink",mergeAttributes(HTMLAttributes)]
    },
    addNodeView(){
        return ReactNodeViewRenderer(DeeplinkView)
    },
})


export default DeeplinkNode;